import React from "react"
import { graphql, Link } from 'gatsby';
import GalleryCollection from "../components/GalleryCollection/GalleryCollection"
import 'semantic-ui-css/semantic.min.css';
import * as styles from "./index.module.css"
import Img from 'gatsby-image';
import "./index.css"
import { Grid, Button, Icon } from "semantic-ui-react";

const Picker = ({
  title='Logo',
  imgFixed,
  btnColor,
  link,
}) => (
  <Link to={link}>
    <div className={styles.picker}>
      <div className={styles.logo}>
        <Img title={title} fixed={imgFixed} />
      </div>
        <Button size="large" inverted style={{
          backgroundColor: btnColor || 'teal',
          color: 'white',
        }}>
          NFT Gallery <Icon name="right arrow circle right" />
        </Button>
    </div>
  </Link>
)

const Home = ({
  location,
  data: { ewb, season1 },
}) => {
  // return null;
  return (
    <div className={styles.container}>
      <h1>
        Superchief Gallery NFT
      </h1>
      <div className={styles.picker}>
        <Grid columns="equal" divided stackable>
          <Grid.Row>
            {
              ewb &&
              <Grid.Column>
                <Picker
                  link="/ewb"
                  imgFixed={ewb.childImageSharp.fixed} btnColor="rgb(143, 99, 178)" />
              </Grid.Column>
            }
            {
              season1 &&
              <Grid.Column>
                <Picker
                  link="/season1"
                  imgFixed={season1.childImageSharp.fixed} btnColor="#1c687f" />
              </Grid.Column>
            }
          </Grid.Row>
        </Grid>
      </div>
    </div>
  );
}

export default Home;

export const query = graphql`
  query {
    season1: file(
      sourceInstanceName: { eq: "images" }
      relativePath: { eq: "season1-logo-square.png" }
    ) {
      childImageSharp {
        fixed(height: 130, grayscale: false) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    ewb: file(
      sourceInstanceName: { eq: "images" }
      relativePath: { eq: "ewb-logo-square.png" }
    ) {
      childImageSharp {
        fixed(height: 100, grayscale: false) {
          ...GatsbyImageSharpFixed
        }
      }
    }
  }
`
